import assign from "lodash.assign";
import find from "lodash.find";
import { browserHistory } from "react-router";
import entitlements from "./entitlements";
import manageBulkSubscription from "./manageBulkSubscription";
import appPath from "../utils/appPath";
import { SCREENS } from "common/constants/Constants";
import { SUBSCRIPTION_TYPE } from "common/constants/v2/Constants";

// Actions (must be name-spaced for reducer)

export const MANAGE_SUBSCRIPTION_SET_INFO = "MANAGE_SUBSCRIPTION_SET_INFO";

export function manageSubscriptionReducer(state = {}, action) {
    switch (action.type) {
        case MANAGE_SUBSCRIPTION_SET_INFO:
            return assign({}, state, {
                id: action.id,
                endDate: action.endDate,
                status: action.status
            });
        default:
            return state;
    }
}

export function setSubscriptionInfo({ id, status, endDate }) {
    return {
        type: MANAGE_SUBSCRIPTION_SET_INFO,
        id,
        status,
        endDate
    };
}

export function getSubscription(subscriptionId) {
    return (dispatch) => {
        return dispatch(entitlements.getSubscriptions())
            .then((subscriptions) => {
                const subscription = find(subscriptions, (sub) => {
                    return sub.id === parseInt(decodeURIComponent(subscriptionId));
                });

                return subscription || Promise.reject();
            })
            .then((subscription) => {
                dispatch(setSubscriptionInfo(subscription));

                if (subscription.type === SUBSCRIPTION_TYPE.BULK) {
                    dispatch(manageBulkSubscription.setInfo(subscription.bulkSubscriptionMetadata));
                }
            })
            .catch(() => {
                browserHistory.push(appPath.withoutQuery(SCREENS.SUBSCRIPTIONS));
            });
    };
}

export default {
    setSubscriptionInfo,
    getSubscription
};
